import React from "react";
import { Select, Space } from "antd";
import { useTranslate, useSetLocale } from "@refinedev/core";

const { Option } = Select;

export const LanguageSwitcher: React.FC = () => {
  const t = useTranslate();
  const setLocale = useSetLocale();
  
  const languages = [
    { key: "en", label: t("languageSwitcher.en", "English") },
    { key: "am", label: t("languageSwitcher.am", "Amharic") },
  ];

  const currentLocale = localStorage.getItem("locale") || "en";

  const handleLanguageChange = (value: string) => {
    setLocale(value);
    localStorage.setItem("locale", value);
  };

  return (
    <Space>
      <span>{t("languageSwitcher.switch", "Switch Language")}</span>
      <Select
        defaultValue={currentLocale}
        onChange={handleLanguageChange}
        style={{ width: 120 }}
      >
        {languages.map((lang) => (
          <Option key={lang.key} value={lang.key}>
            {lang.label}
          </Option>
        ))}
      </Select>
    </Space>
  );
};